export const fontMap = {
  branding: 'Typonil, sans-serif',
  heading: 'Typonil, sans-serif',
  text: 'Work Sans, sans-serif',
}
